import React from 'react'
import '../../Styles/ErrorPage.css';

const ErrorPage = () => {
    return ( 
        <div className="errorPage">
            <h3>OOps, there's nothing here,</h3>

        </div>
     );
}
 
export default ErrorPage;